import { render, staticRenderFns } from "./dcPxWjXj.vue?vue&type=template&id=240bc3a1&scoped=true&"
import script from "./dcPxWjXj.vue?vue&type=script&lang=js&"
export * from "./dcPxWjXj.vue?vue&type=script&lang=js&"
import style0 from "./dcPxWjXj.vue?vue&type=style&index=0&id=240bc3a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240bc3a1",
  null
  
)

export default component.exports